export default {
  title: "Email address",
  input: {
    title: "{{action}} email address",
    email: {
      label: "Email address"
    },
    type: {
      label: "Email address type"
    },
  },
  view: {
    noItems: {
      title: "No email addresses",
      text: "Click to add an email address",
    },
  }
}
